export default {
    path: '/dashboard',
    meta: {
        menuLabel: 'Learning Portal',
    },
    components: {
        default: () => import('../../views/memberDashboard/dashboard/index.vue'),
        header: () => import('../../views/memberDashboard/header/index.vue'),
        footer: () => import('../../views/public/footer/index.vue'),
    },
    children: [
        {
            path: '',
            name: 'memberDashboard.dashboard',
            meta: {
                menuLabel: 'My Dashboard',
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member', 'credential_member']
                }
            },
            component: () => import('@/modules/member/components/dashboard')
        },
        {
            path: 'classroom',
            redirect: '/dashboard',
        },
        {
            path: 'classroom/catalogue',
            name: 'memberDashboard.classroom.catalogue',
            meta: {
                menuLabel: 'Membership Courses',
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member']
                }
            },
            component: () => import('../../views/memberDashboard/dashboard/components/catalogue.vue'),
        },
        {
            path: 'classroom/results',
            name: 'memberDashboard.classroom.results.',
            meta: {
                menuLabel: 'Certificates & History',
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member']
                }
            },
            component: () => import('../../views/memberDashboard/dashboard/components/results.vue'),
        },
        // {
        //     path: 'events',
        //     name: 'memberDashboard.classroom.events',
        //     meta: {
        //         menuLabel: 'My Events',
        //         middleware: {
        //             mustBeAuthenticated: true,
        //             mustHasRoles: ['member']
        //         }
        //     },
        //     component: () => import('@/views/memberDashboard/dashboard/MemberEvents.vue'),
        // },
        {
            path: 'classroom/wishlist',
            name: 'memberDashboard.classroom.wishlist',
            meta: {
                menuLabel: 'Wishlist',
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member']
                }
            },
            component: () => import('../../views/memberDashboard/dashboard/components/wishlist.vue'),
        },
        {
            path: 'classroom/skills',
            name: 'memberDashboard.classroom.skills',
            meta: {
                menuLabel: 'Skills Tracker',
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member']
                }
            },

            component: () => import('@/modules/member/components/classroom-skills'),
        }
    ]
}
